import { Route, Routes } from "react-router-dom";
import FourZeroFour from "./components/FourZeroFour/index";
import Home from "./components/Home";
import Careers from "./components/Careers/index";
import PrivacyPolicySection from "./components/Privacy/PrivacyOne";
import RiderPolicy from "./components/Privacy/RiderPolicy";
import ScrollToTop from "./components/ScrollToTop";

import Header from "./components/Header";
import Footer from "./components/Footer";

export default function Routers() {
    return (
        <div style={{overflowX: "hidden"}}>
            <ScrollToTop />
            <Header/>
            <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route exact path="/privacy-policy" element={<PrivacyPolicySection/>}/>
                <Route exact path="/rider-policy" element={<RiderPolicy/>}/>
                <Route exact path="/404" element={<FourZeroFour/>}/>
                <Route exact path="/careers" element={<Careers/>}/>
                <Route exact path="/careers/" element={<Careers/>}/>
                <Route path="/careers/:jobSlug" element={<Careers/>}/>

            </Routes>
            <Footer/>
        </div>
    );
}
